export const VerticalDots = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 128 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" />
  </svg>
);
